import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig from '../useGetFetchConfig';
import { SkippedFile } from '@/api/types/backend-dto-types';

export const useGetSkippedFiles = (matterId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<SkippedFile[]>(
    [QueryEntity.SkippedFiles, { matterId }],
    () => {
      return fetch(`${APIBaseChronos}/api/matter/${matterId}/upload-metadata/skipped`, fetchConfigGET).then((res) => {
        return res.json();
      });
    },
    {
      enabled: !!matterId,
      refetchOnWindowFocus: false,
    },
  );
};
